import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <p>ZeZo © 2025 | praveenhari  creations</p>
        </footer>
    );
};

export default Footer;
